module.exports = __webpack_public_path__ + "static/bim-viewer-0b25c66173cf4c05c1b56f32a331d04d.png";